import { useSwrNoAuth } from "../../swr/useSwrNoAuth";

export const useFetchLiffIdCustomerByRestaurantId = (restaurantId: string, liffType: string) => {
  const { data: liffId, error, isLoading } = useSwrNoAuth<string>(`external_api/restaurants/${restaurantId}/liff-restaurants/${liffType}/liff-id/`)
  return { liffId, isLoading, error };
};